export const GOOGLE_RECAPTCHA_SITE_KEY =
  '6Lc7Ks8oAAAAANSzjxYplXqiooW7-Jf6RFxXhRpi';
